/**
 * Product Configuration Data
 * 
 * This file contains the definition of all products, their GS1 identifiers, 
 * and associated data folders. Add new products here.
 */

export const productConfig = {
  "baseUrl": "http://localhost:3000",
  // Common path pattern for GS1 Digital Link (used for dynamic routing)
  "path": "/01/:gtin/21/",  
  "description": "Base URL and path configuration. Path uses GS1 Digital Link standard format.",
  "defaultProduct": "linqOne",
  "products": {
    "linqOne": {
      "name": "Smart Mobile Device",
      "displayName": "Linq One Pro S1",
      "dataFolder": "linqOne",
      "serialNumber": "F2L9Q3X7N6Y8",
      "gtin": "0195949123456",
      "authenticatedImage": "QR.png",
      "qrCodes": {
        "verified": {
          "serialNumber": "F2L9Q3X7N6Y8",
          "qrImage": "linqoneqr-success_qr.png",
          "authenticatedImage": "QR.png",
          "status": "verified",
          "hash": "#verified"
        },
        "suspected": {
          "serialNumber": "F2L9Q3X7N6Y9",
          "qrImage": "linqone_suspected_qr.png",
          "authenticatedImage": "QR.png",
          "status": "suspected",
          "hash": "#suspected"
        },
        "expired": {
          "serialNumber": "F2L9Q3X7N6Y7",
          "qrImage": "linqone_expired_qr.png",
          "authenticatedImage": "QR.png",
          "status": "expired",
          "hash": "#expired"
        }
      },
      "description": "Premium smart device with digital product passport"
    },
    /*"chocolate": {
      "name": "Premium Dark Chocolate",
      "displayName": "Neuhaus - Belgium 1857",
      "dataFolder": "chocolate",
      "serialNumber": "NEU8D5T2K9P4",
      "gtin": "5410546881213",
      "authenticatedImage": "Neuhaus_chocolate.webp",
      "qrCodes": {
        "verified": {
          "serialNumber": "NEU8D5T2K9P4",
          "qrImage": "chocolate-1.png",
          "authenticatedImage": "Neuhaus_chocolate.webp",
          "status": "verified",
          "hash": ""
        },
         "suspected": {
          "serialNumber": "NEU8D5T2K9P5",
          "qrImage": "chocolate-suspectedQr.png",
          "authenticatedImage": "Neuhaus_chocolate.webp",
          "status": "suspected",
           "hash": "#suspected"
        },
        "expired": {
          "serialNumber": "NEU8D5T2K9P6",
          "qrImage": "chocolate-expiredQr.png",
          "authenticatedImage": "Neuhaus_chocolate.webp",
          "status": "expired",
           "hash": "#expired"
        }
      },
      "description": "Fair trade organic dark chocolate with full supply chain traceability"
    },*/
    "chocolateFictional": {
      "name": "Premium Dark Chocolate 72%",
      "displayName": "H2CWPTCHOCO - Belgium 1892",
      "dataFolder": "chocolate-fictional",
      "serialNumber": "MDX7C2A8K5P9",
      "gtin": "05420789654322",
      "authenticatedImage": "fictional-choco.jpg",
      "qrCodes": {
        "verified": {
          "serialNumber": "MDX7C2A8K5P9",
          "qrImage": "chocolate-fictional-successQR.png",
          "authenticatedImage": "fictional-choco.jpg",
          "status": "verified",
          "hash": "#verified"
        },
         "suspected": {
          "serialNumber": "MDX7C2A8K5P0",
          "qrImage": "chocolate-fictional-suspectedQR.png",
          "authenticatedImage": "fictional-choco.jpg",
          "status": "suspected",
           "hash": "#suspected"
        },
        "expired": {
          "serialNumber": "MDX7C2A8K5P1",
          "qrImage": "chocolate-fictional-expiredQR.png",
          "authenticatedImage": "fictional-choco.jpg",
          "status": "expired",
           "hash": "#expired"
        }
      },
      "description": "Artisan Belgian dark chocolate with single-origin Ecuadorian cocoa"
    },
     "wipotech-chocolates": {
      "name": "H2Compute",
      "displayName": "Interpack Chocolate Truffles",
      "dataFolder": "wipotech-chocolates",
      "serialNumber": "828232932392",
      "gtin": "05420789654321",
      "gtins": ["05420789654321", "05420789654327"],
      "authenticatedImage": "h2wipo-choco.jpg",
      "qrCodes": {
        "verified1": {
          "serialNumber": "828232932392",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified", 
          "hash": "verified"
        },
        "verified2": {
          "serialNumber": "342313513555",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": "verified"
        },
        "verified3": {
          "serialNumber": "343423523532",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": "verified"
        },
        "verified4": {
          "serialNumber": "235235662133",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": "verified"
        },
        "verified5": {
          "serialNumber": "509584848321",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": ""
        },
        "verified6": {
          "serialNumber": "235253251311",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": "verified"
        },
        "verified7": {
          "serialNumber": "352352353255",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": "verified"
        },
        "verified8": {
          "serialNumber": "358983258238",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": "verified"
        },
        "verified9": {
          "serialNumber": "213423523523",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": "verified"
        },
        "verified10": {
          "serialNumber": "325823599235",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": "verified"
        },
        "verified11": {
          "serialNumber": "235235532552",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": "verified"
        },
        "verified12": {
          "serialNumber": "235562341333",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": "verified"
        },
        "verified13": {
          "serialNumber": "352135355133",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": "verified"
        },
        "verified14": {
          "serialNumber": "353532133113",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": "verified"
        },
        "verified15": {
          "serialNumber": "235564373773",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": "verified"
        },
        "verified16": {
          "serialNumber": "325235626266",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": "verified"
        },
        "verified17": {
          "serialNumber": "242424235235",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": "verified"
        },
        "verified18": {
          "serialNumber": "352352353532",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": "verified"
        },
        "verified19": {
          "serialNumber": "235235235235",
          "qrImage": "wipotech-successQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "verified",
          "hash": "verified"
        },
         "suspected": {
          "serialNumber": "235235235211",
          "qrImage": "wipotech-suspectedQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "suspected",
           "hash": "#suspected"
        },
        "expired": {
          "serialNumber": "235235235223",
           "qrImage": "wipotech-expiredQR.png",
          "authenticatedImage": "h2wipo-choco.jpg",
          "status": "expired",
           "hash": "#expired"
        }
      },
      "description": "Wipotech dark chocolate with single-origin Ecuadorian cocoa"
    },
    "Munchee-Tikiri-Marie": {
      "name": "Biscuit",
      "displayName": "Munchee Tikiri Marie",
      "dataFolder": "munchee-tikiri-marie",
      "serialNumber": "628232932380",
      "gtin": "05420789654368",
      "authenticatedImage": "Munchee-Tiki Marie.jpg",
      "qrCodes": {
        "verified": {
          "serialNumber": "628232932380",
          "qrImage": "Munchee-Tiki-Marie-successQR.png",
          "authenticatedImage": "Munchee-Tiki Marie.jpg",
          "status": "verified",
          "hash": "#verified"
        },
         "suspected": {
          "serialNumber": "628232932381",
          "qrImage": "Munchee-Tiki-Marie-suspectedQR.png",
          "authenticatedImage": "Munchee-Tiki Marie.jpg",
          "status": "suspected",
           "hash": "#suspected"
        },
        "expired": {
          "serialNumber": "628232932382",
          "qrImage": "Munchee-Tiki-Marie-expiredQR.png",
          "authenticatedImage": "Munchee-Tiki Marie.jpg",
          "status": "expired",
           "hash": "#expired"
        }
      },
      "description": "Light, crispy milk biscuits with mild sweetness - a classic Sri Lankan tea-time favorite. Net Weight: 80g. Made by Ceylon Biscuits Limited."
    },
    "Hemas Clogard": {
      "name": "Toothpaste",
      "displayName": "Clogard Cavity Protection Toothpaste",
      "dataFolder": "hemas-clogard",
      "serialNumber": "628232932370",
      "gtin": "05420789654369",
      "authenticatedImage": "Hemas-Clogard.jpg",
      "qrCodes": {
        "verified": {
          "serialNumber": "628232932370",
          "qrImage": "Hemas-Clogard-successQR.png",
          "authenticatedImage": "Hemas-Clogard.jpg",
          "status": "verified",
          "hash": "#verified"
        },
         "suspected": {
          "serialNumber": "628232932371",
          "qrImage": "Hemas-Clogard-suspectedQR.png",
          "authenticatedImage": "Hemas-Clogard.jpg",
          "status": "suspected",
           "hash": "#suspected"
        },
        "expired": {
          "serialNumber": "628232932372",
          "qrImage": "Hemas-Clogard-expiredQR.png",
          "authenticatedImage": "Hemas-Clogard.jpg",
          "status": "expired",
           "hash": "#expired"
        }
      },
      "description": "Fluoride toothpaste with natural clove oil for cavity protection. Contains 1000–1500 ppm fluoride to help protect enamel and maintain oral health. Manufactured by Hemas Manufacturing (Pvt) Ltd., Sri Lanka. Net Weight: 120g."
    },
    "Shan Teas": {
      "name": "Shan Teas",
      "displayName": "Pure Ceylon Black Tea",
      "dataFolder": "shan-teas",
      "serialNumber": "628232932390",
      "gtin": "05420789654370",
      "authenticatedImage": "shan-teas.jpg",
      "qrCodes": {
        "verified": {
          "serialNumber": "628232932390",
          "qrImage": "shan-teas-successQR.png",
          "authenticatedImage": "shan-teas.jpg",
          "status": "verified",
          "hash": "#verified"
        },
         "suspected": {
          "serialNumber": "628232932391",
          "qrImage": "shan-teas-suspectedQR.png",
          "authenticatedImage": "shan-teas.jpg",
          "status": "suspected",
           "hash": "#suspected"
        },
        "expired": {
          "serialNumber": "628232932392",
          "qrImage": "shan-teas-expiredQR.png",
          "authenticatedImage": "shan-teas.jpg",
          "status": "expired",
           "hash": "#expired"
        }
      },
      "description": "Premium 100% Pure Ceylon Black Tea crafted from carefully selected tea leaves sourced from Sri Lanka's renowned tea-growing regions. Expertly blended to deliver a rich aroma, bright liquor, and distinctive taste. Produced and packed by Shan Teas (Private) Limited, Sri Lanka, under internationally recognized food safety and quality standards. A perfect representation of authentic Ceylon tea heritage."
    },
  },
  "routes": {
    "onboard": "onboard",
    "scanqr": "scanqr",
    "verification": "verification",
    "dpp": "dpp",
    "map": "map",
    "ccmap": "ccmap",
    "gs1": "gs1",
    "temperatureGraph": "temperature-graph"
  },
   "verificationStates": {
    "verified": {
      "themeKey": "green",
      "title": "Verified Product",
      "message": "This product is genuine"
    },
    "suspected": {
      "themeKey": "suspected",
      "title": "Suspicious Product",
      "message": "This code was scanned more than 250 times in different locations."
    },
    "expired": {
      "themeKey": "expired",
      "title": "Expired Product",
      "message": "This is a verified but expired product. Please contact your nearest provider for proper disposal."
    }
  }
};
